import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFuelTankList as getFuelTankListApi,
	getFuelTank as getFuelTankApi,
	addNewFuelTank as addNewFuelTankApi,
	updateFuelTank as updateFuelTankApi,
	deleteFuelTank as deleteFuelTankApi,
	getFuelTankListByEstablishment as getFuelTankListByEstablishmentApi,
} from '../../helpers/establishment/backend_helper';

export const getFuelTankList = createAsyncThunk('fuelTank/getFuelTankList', async (params) => {
	try {
		const response = getFuelTankListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFuelTankListByEstablishment = createAsyncThunk('fuelTank/getFuelTankListByEstablishment', async (params) => {
	try {
		const response = getFuelTankListByEstablishmentApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFuelTank = createAsyncThunk('fuelTank/getFuelTank', async fuelTank_id => {
	try {
		const response = getFuelTankApi(fuelTank_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewFuelTank = createAsyncThunk('fuelTank/addNewFuelTank', async fuelTank => {
	try {
		const response = addNewFuelTankApi(fuelTank);
		toast.success('Estanque de Combustible agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar fuelTank.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFuelTank = createAsyncThunk('fuelTank/updateFuelTank', async (fuelTank) => {
		try {
			const response = updateFuelTankApi(fuelTank);
			toast.success('Estanque de Combustible actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar fuelTank.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFuelTank = createAsyncThunk('fuelTank/deleteFuelTank', async fuelTank => {
	try {
		const response = await deleteFuelTankApi(fuelTank);
		toast.success('Estanque de Combustible eliminado exitosamente.', { autoClose: 3000 });
		return { fuelTank, ...response };
	} catch (error) {
		toast.error('Error al eliminar fuelTank.', { autoClose: 3000 });
		throw new Error(error);
	}
});



